// extracted by mini-css-extract-plugin
export var circle = "_34-2";
export var icon = "_34-a";
export var iconHighlight = "_34-0";
export var lg = "_34-8";
export var md = "_34-7";
export var outline = "_34-4";
export var sm = "_34-6";
export var square = "_34-1";
export var xl = "_34-9";
export var xs = "_34-5";
export var xxs = "_34-3";